import styled, { css } from 'styled-components'
import { COLORS } from 'consts/colors'
import { CONTROL, RADII } from 'styles/consts'

export const ButtonWithIcon = styled.button<{ $isDisabled?: boolean }>`
  width: 100%;
  height: ${CONTROL.height};
  display: flex;
  align-items: center;
  background-color: ${COLORS.white};
  gap: 10px;
  padding: 12px 10px;
  border-radius: ${RADII.field};
  border: 1px solid ${COLORS.borderColor};
  box-sizing: border-box;
  transition: all 0.2s ease;
  cursor: pointer;

  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      opacity: 0.5;
      pointer-events: none;
    `}

  & > span {
    font-size: 12px;
    font-weight: 500;
    color: ${COLORS.textSecondary};
  }

  & > svg {
    fill: ${COLORS.textSecondary};
  }

  &:hover {
    & > span {
      color: ${COLORS.textPrimary};
    }

    & > svg {
      fill: ${COLORS.textPrimary};
    }

    & > svg path {
      fill: ${COLORS.textPrimary};
    }

    background-color: ${COLORS.fill};
  }
`
